import React from "react";
import styled, { ThemeProvider } from "styled-components";
import theme from "./../../themes/default";

const Wrap = styled.div`
    @media (min-width: 990px) {
        max-width: calc(100% - 352px);
        flex: 1;
        padding-right: 32px;
    }
`;

export default function ContentInner(props) {
    return (
        <ThemeProvider theme={theme}>
            <Wrap>{props.children}</Wrap>
        </ThemeProvider>
    );
}
